var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFsAmountIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.5c-3.516 0-5.762 2.381-5.982 5.491L6 8l-3 4-3-4 2.013 1.007C2.238 4.854 5.293 1.5 10 1.5c3.659 0 6.683 2.075 8 5L16.5 6 16 7.5c-.993-2.206-3.126-4-6-4zm0 13c3.516 0 5.762-2.381 5.982-5.491L14 12l3-4 3 4-2.013-1.007C17.762 15.146 14.707 18.5 10 18.5c-3.659 0-6.684-2.075-8-5l1.5.5.5-1.5c.993 2.206 3.126 4 6 4z",
    fill: "#9A9CAC"
  })));
}

export default SvgFsAmountIcon;